<template>
    <div class="d-flex justify-content-end align-items-center gap-2">
        <DownloadCsv :resourceName='resourceName' :fileName='resourceName' :options="options" />
        <button class="btn btn-primary" @click="openModal" :disabled="disabled">
            <i class="fa-regular fa-file-arrow-up"></i>
            <span class="text">{{ pluralName }}</span>
        </button>
    </div>

    <ImportModal ref="importModal" :pluralName="pluralName" :resourceName="resourceName" :options="options">
        <template #body>
            <slot name="modal-body" />
        </template>
    </ImportModal>
</template>

<script>
import DownloadCsv from "@/components/DownloadCsv/DownloadCsv.vue";
import ImportModal from "@/components/Import/ImportModal.vue";

export default {
    name: "ImportButton",
    components: {
        DownloadCsv,
        ImportModal
    },
    props: {
        resourceName: { type: String, required: true },
        pluralName: { type: String, required: true },
        disabled: { type: Boolean, default: false },
        options: { type: Object, default: () => ({}) }
    },
    methods: {
        openModal() {
            this.$refs.importModal.openModal();
        },
    }
};
</script>